<template>
  <div class="login-container">
    <div class="login-left">
      <div class="left-main"><img src="@/assets/images/left-main.png" /></div>
    </div>
    <div class="login-right">
      <div class="right-main">
        <h3 class="title">{{$t('system.title')}}</h3>
        <el-form 
          autoComplete="on" 
          :model="loginForm"  
          size='default' 
          :rules="loginRules" 
          ref="loginForm" 
          class="login-form">
          <el-form-item prop="username">
            <el-input name="username" prefix-icon="el-icon-user" type="text" v-model.trim="loginForm.username" autoComplete="on" :placeholder="$t('system.username')" />
          </el-form-item>
          <el-form-item prop="password" class="password-box">
            <el-input name="password" prefix-icon="el-icon-lock" :type="pwdType" @keyup.enter.native="handleLogin" v-model="loginForm.password" autoComplete="on"
            :placeholder="$t('system.password')"></el-input>
          </el-form-item>
          <el-form-item class="btn">
              <el-button class="btn-login" type="primary" :loading="loading" @click.native.prevent="handleLogin">{{$t('system.login')}}</el-button>
          </el-form-item>
        </el-form>
        <div class="foot_copy" v-html="$store.state.system.copyright"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'login',
  data() {
    // 密码校验 长度不能小于8位且不能大于20位字符,必须包含大写字母、小写字母、数字和特殊符号
    // var ISPWD =/^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\._\+(){}])[0-9a-zA-Z!@#$%^&*,\\._\+(){}]{8,20}$/;

    // 密码校验 密码长度8-20个字(大写字母、小写字母、数字、特殊字符至少两项！)
    var ISPWD_HCKJ =/^(?![\d]+$)(?![a-z]+$)(?![A-Z]+$)(?![\W_]+$)[\da-zA-z\W_]{8,20}$/;
    var ISPWD =/^.{6,20}$/;
	  // 密码校验
    const validatePassword = (rule, value, callback) =>{
      if(this.loginForm.username=='HCKJ'){
        if (!ISPWD_HCKJ.test(this.loginForm.password)) {
          callback(new Error(this.$t('system.password_tip1')));
        } else {
          callback();
        }
      } else {
        if (!ISPWD.test(this.loginForm.password)) {
          callback(new Error(this.$t('system.password_tip2')));
        } else {
          callback();
        }
      }
      
    }
    return {      
      loginForm: {
        login_type: 1,
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, trigger: 'blur', message: this.$t('system.please_username') },
          { min: 4, max: 11, message: this.$t('system.username_tip'), trigger: 'blur' }
        ],
        password: [
          { required: true, trigger: 'blur', message: this.$t('system.password_tip3') },
          // { min: 8, max: 20, message: '密码长度在 8 - 20 个字', trigger: 'blur' },
          { required: true, validator: validatePassword, trigger: 'blur' }
        ]
      },
      loading: false,
      redirect: undefined,
      pwdType: 'password',
      isLogin: 0
    }
  },
  async created(){
    let isLogin=this.$route.query.isLogin;
    let user=this.$route.query.user;
    this.redirect=this.$route.query.redirect;
    if(isLogin) {
      if(!user){
        this.$message.error(this.$t('system.username_tip'));
        return
      }
      this.isLogin = isLogin
      this.noLogin()
    }
  },
  methods: {
    showPwd() {
      if (this.pwdType === 'password') {
        this.pwdType = ''
      } else {
        this.pwdType = 'password'
      }
    },
    noLogin() {
      let noLoginData = {
        username: this.$route.query.user,
        password: 'a12345678'
      }
      this.loading = true
      this.$store.dispatch('login', noLoginData).then((res) => {
        this.loading = false
        if(res.code==1000){
          if(this.redirect&&this.redirect!=undefined){
            this.$router.push({ path: this.redirect || '/index' })
          }else{
            this.$router.push({ path: '/index' })
          }
        }else{
          return this.$message({
            message: res.message || this.$t('system.error'),
            type: 'error',
            duration: 3 * 1000
          });
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          if (this.loginForm.password === this.loginForm.username || this.loginForm.password === this.loginForm.username.split('').reverse().join('')) {
            return this.$message({
              message: this.$t('system.password_tip4'),
              type: 'error',
              duration: 3 * 1000
            });
          }

          this.loading = true
          this.$store.dispatch('login', this.loginForm).then((res) => {
            this.loading = false
            if(res.code==1000){
              this.$router.push({ path: this.redirect || '/device/lamps' });
            }else{
              return this.$message({
                message: res.message || this.$t('system.error'),
                type: 'error',
                duration: 3 * 1000
              });
            }
          }).catch(() => {
            this.loading = false
          })
        } else {
          return false
        }
      })
    }

  }
}
</script>
<style lang="less">
@dark_gray:#889aa4;
@light_gray:#eee;
@active:#85e6fc;
.login-container {
  position: relative;
  height: 100vh;
  width:100%;
  display: flex;
  overflow: hidden;
  align-items: center;
  .login-left{
    width: 50%;
    height:100vh;
    background:url('../assets/images/left-bg.png') no-repeat;
    background-size: 100% 100%;
    position: relative;
    overflow: hidden;
    .left-main{
      width: 63%;
      left:5.8333%;
      bottom: 5%;
      position: absolute;
      z-index: 99;
      img{
        width: 100%;
        height: auto;
      }
    }
  }
  .login-right{
    width: 50%;
    height:100vh;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    .right-main{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .title {
        margin: 12px auto 20px;
        text-align: center;
        font-size: 38px;
        color: #193d7b;
        font-weight: bold;
        font-family: Microsoft yahei pingfang SC;
      }
    }


    .login-form {
      border-radius: 5px;
      background-clip: padding-box;
      width: 440px;
      padding: 30px 0;
      .el-form-item{
        margin-bottom: 30px !important;
        .el-input__inner{
          appearance: none;
          height: 50px !important;
          color:#111;
          border-radius: 50px;
          background-color: #f2f2f2;
          font-size: 16px;
          padding: 0 45px;
          &:focus,&:hover{
            border-color: #193d7b;
          }
        }
        .el-input__prefix{
          font-size: 18px;
          color:#888;
          left:12px;
          top:2px;
        }
      }
      .el-form-item__error{
        padding-top: 5px;
        padding-left: 15px;
      }
    }
    .btn {
      text-align: center;
    }
    .btn-login{
      width: 100%;
      padding: 16px 20px;
      height: auto;
      background-color: #193d7b !important;
      border-color: #193d7b !important;
      font-size: 16px;
      font-weight: bold;
      border-radius: 50px;
      margin-top: 10px;
      letter-spacing: 1px;
      &:hover{
        background-color: #2a56a1 !important;
        border-color: #2a56a1 !important;
      }
    }

    
    .el-input__inner::placeholder{
      color:#777 !important
    }
    .password-box{
      height:50px;
      align-items: flex-start;
    }

    .foot_copy{
      width:100%;
      height:30px;
      bottom: 10px;
      color: #777;
      text-align: center;
      position: absolute;
      z-index: 999;  
      left:0;
      font-size:14px;
    }
    .foot_copy a{
      color:#333;
      font-weight: bold;
      display:inline-block;
    }
    .el-form-item__content{
      height:auto;
    }
  }
}
</style>
